/**
 * UC-03: LoadGame
 * Restores a game snapshot from IGameRepository with validator-backed recovery.
 */
import type { IAppLogger } from '../../domain/ports/IAppLogger';
import type { GameSaveSnapshot, IGameRepository } from '../../domain/ports/IGameRepository';

export interface LoadGameDependencies {
  repository: IGameRepository;
  logger?: IAppLogger;
}

export class LoadGameUseCase {
  constructor(private readonly deps: LoadGameDependencies) {}

  async execute(): Promise<GameSaveSnapshot | null> {
    const snapshot = await this.deps.repository.load();

    if (snapshot) {
      this.deps.logger?.log('info', 'game.loaded', {
        day: snapshot.stats.day,
        gameStatus: snapshot.gameStatus,
        version: snapshot.version,
      });
    } else {
      this.deps.logger?.log('warn', 'game.load.miss', {});
    }

    return snapshot;
  }

  hasSave(): boolean {
    return this.deps.repository.hasSave();
  }
}